import theme from '@styles/theme';

export default {
  section: {
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    width: '100%',
    height: ['150vw', '155vw', '155vw', '155vw', '46.875vw'],
    background: theme.rawColors.lightGrey300,
  },
  imageContainer: {
    height: ['150vw', '155vw', '155vw', '155vw', '46.875vw'],
    position: 'absolute',
    overflow: 'hidden',
    bottom: 0,
    left: 0,
    right: 0,

    img: {
      transition: 'opacity .15s',
      height: '100%',
      width: '100%',
    },
  },
  contentStyles: {
    position: 'absolute',
    top: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: ['space-between', 'space-between', 'space-between', 'flex-end'],
    bottom: [0, 0, '100px'],
    left: '50%',
    transform: 'translateX(-50%)',
    maxWidth: '1560px',
    'h2.display__three.mobile': {
      color: [theme.rawColors.darkGrey700, theme.rawColors.darkGrey700, theme.rawColors.neutralWhite],
      p: ['40px 16px 24px', '40px 16px 24px', '68px 24px 0', '0'],
      m: ['0 auto', '0 auto', '0 0 35.25px'],
      width: ['300px', '300px', 'auto'],
    },
  },

  columnsContainer: (numberOfColumns = 8) => ({
    width: '100%',
    height: ['100%', '100%', 'auto'],
    display: 'flex',
    justifyContent: 'space-around',
    p: ['0 0 2px', '0 0 2px', '0 40px 2px'],
    '.swiper-wrapper': {
      position: ['absolute', 'absolute', 'relative'],
      bottom: '0',
      display: 'grid',
      gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`,
    },
    '.swiper-slide': {
      width: ['50%', '50%', '372px'],
      display: ['flex', 'flex', 'grid'],
      alignItems: 'end',
      pb: ['54px', '54px', '0'],
    },
    '.swiper-pagination': {
      display: ['flex', 'flex', 'none'],
      width: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      bottom: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      '.swiper-pagination-bullet': {
        width: '9px',
        height: '6px',
        background: theme.rawColors.lightGrey500,
        borderRadius: '0',
        transition: 'background .2s linear',
        opacity: 'unset',
        m: '22px 4px 0',
        '&.swiper-pagination-bullet-active': {
          background: theme.rawColors.darkGrey700,
          opacity: 'unset',
        },
      },
    },
  }),
  columnStyles: {
    position: ['absolute', 'absolute', 'relative'],
    bottom: ['54px', '54px', '0'],
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  columnText: {
    color: '#fff',
    fontSize: ['20px', '20px', '20px', '24px'],
    lineHeight: '140%',
    letterSpacing: '0.05em',
    textAlign: 'center',
    margin: '16px 0',
  },
  button: {
    width: ['170px', '170px', 'auto'],
    '.a-voxButton__linkText': {
      fontSize: theme.fontSizes.text,
    },
  },
  itemHeading: {
    minHeight: ['0', '0', '80px', 'auto'],
  },
};
